const state = {
  allEvents: [], 
  sharedEvents: [],
  currentRoutedEvent: '', 
  currentUserLocation: ''
}

// Synchronous Updates
const mutations = {
  ADD_EVENT(state, event){
    //Add data locally 
    state.allEvents.push(event)
  }, 

  ADD_SHARED_EVENT(state, event){
    //Add data locally 
    state.sharedEvents.push(event);
  }, 

  UPDATE_CURRENT_EVENT(state, event){
    //Update currentRoutedEvent 
    state.currentRoutedEvent = event

    for(var i = 0; i < state.allEvents.length; i++){
      if(state.allEvents[i].id == event.id){
        state.allEvents[i] = event
      }
    }
  },

  DELETE_EVENTBYID(state, eventId){
    for(var i = state.allEvents.length - 1; i >= 0; --i){
      if(state.allEvents[i].id == eventId){
        state.allEvents.splice(i, 1);
      }
    }
  },

  SET_ROUTED_EVENTID(state, eventId){
    const result = state.allEvents.filter(event => {event.id == eventId})
    state.currentRoutedEvent = result;
  },

  SET_ROUTED_EVENT(state, event){
    state.currentRoutedEvent = event;
  },

  CLEAR_EVENTS(state){
    while(state.allEvents.length > 0){
      state.allEvents.pop()
    }
  }
}

const getters = {
  getCurrentRoutedEvent: (state) => {
    return state.currentRoutedEvent;
  }, 
  getPastEvents: (state) => {
    return state.allEvents.concat(state.sharedEvents).filter(event => {
      const today = new Date();
      const eventStart = new Date(event.date);

      return eventStart < today;

    })

    return state.allEvents.filter(event => {

      const eventStart = event.date && event.startTime ? new Date(event.date+' '+event.startTime) : event.date ? new Date(event.date) : null;
      const eventStop = event.endDate && event.endTime ? new Date(event.endDate+' '+event.endTime) : event.endDate ? new Date(event.endDate) : null;

      return (eventStart != null && eventStop != null) ? eventStop < today : eventStart < today;

    })
  }, 
  getFutureEvents: (state) => {
    return state.allEvents.concat(state.sharedEvents).filter(event => {
      const today = new Date()
      const eventStart = new Date(event.date)

      return eventStart > today
    })
  }
}

// Async actions
const actions = {
  async getEvents ({commit, rootState}) {
    // let eventsRef = rootState.db.collection('users').doc(rootState.users.currentUser).collection('events');
    let eventsRef = rootState.db.collection('events').where("ownerId", "==", rootState.users.currentUser)
    var events = await eventsRef.get()

    events.forEach((event) => {
      const eventData = event.data()
      // console.log(eventData)
      commit('ADD_EVENT', eventData)
    });
  },

  async getSharedEvents({commit, rootState}) {
    let eventsRef = rootState.db.collection('events').where('attendeeEmails', 'array-contains', rootState.users.user.email)
    let events = await eventsRef.get()

    events.forEach((event) => {
      const eventData = event.data()
      eventData.isShared = true;
      if(!eventData.attendeeEmails.includes(eventData.owner.email)){
        commit('ADD_SHARED_EVENT', eventData);
      }
      // commit('ADD_EVENT', eventData);
    })
  },

  clearEvents({commit, rootState}) {
    commit('CLEAR_EVENTS')
  },

  async addEvent({commit, rootState}, event) {
    let start = new Date(`${event.date} ${event.startTime}`);
    let end = event.endDate != null && event.endTime != null
          ? new Date(`${event.endDate} ${event.endTime}`) 
          : new Date(start.getTime());

    if(start.toString() == end.toString()){
      end.setHours(start.getHours()+1);
    }

    let newEvent = {
        name: event.name, 
        geometry: {
          location: {
            lat: event.location.geometry.lat(), 
            lng: event.location.geometry.lng()
          }
        },
        address: event.location.address, 
        date: event.date, 
        endDate: event.endDate,
        startTime: event.startTime, 
        endTime: event.endTime, 
        start: start.toString(),
        end: end.toString(),
        id: event.id, 
        owner: rootState.users.user, 
        ownerId: rootState.users.currentUser,
        type: event.type,
        attendeeEmails: (event.attendeeEmails == null ? [] : event.attendeeEmails),
        locations: (event.locations == null ? [] : event.locations),
    }

    // let eventsRef = rootState.db.collection('users').doc(rootState.users.currentUser).collection('events');
    let eventsRef = rootState.db.collection('events');
    await eventsRef.doc(event.id).set(newEvent); //This was changed to async 

    commit('ADD_EVENT', newEvent)
  },

  async updateEvent({commit, rootState}, event){
    // There's two ways to update data .set() and .update()... no clue what the difference is
    //    if this causes issues, will need to update

    let newEvent = {
        name: event.name, 
        geometry: {
          location: {
            lat: event.geometry.location.lat, 
            lng: event.geometry.location.lng
          }
        },
        address: event.address, 
        date: event.date, 
        endDate: event.endDate,
        startTime: event.startTime, 
        endTime: event.endTime, 
        start: event.start ,
        end: event.end,
        id: event.id, 
        owner: event.owner, 
        ownerId: event.ownerId,
        type: event.type,
        map: event.map, 
        attendeeEmails: (event.attendeeEmails == null ? [] : event.attendeeEmails), 
        locations: (event.locations == null ? [] : event.locations)
    }

    let eventsRef = rootState.db.collection('events');
    await eventsRef.doc(event.id).set(newEvent); //This was changed to async 

    commit('UPDATE_CURRENT_EVENT', newEvent)

  },

  async deleteEventById({commit, rootState}, eventId){
    let eventsRef = rootState.db.collection('events');
    await eventsRef.doc(eventId).delete()

    commit('DELETE_EVENTBYID', eventId)
  },

  async getEventById({commit, rootState}, id){
    var foundEvent = state.allEvents.find(event => event.id == id)
    if(foundEvent){
      commit('SET_ROUTED_EVENT', foundEvent);
    } else{
      let eventsRef = rootState.db.collection('events');
      const event = await eventsRef.doc(id).get()
      commit('SET_ROUTED_EVENT', event.data())
    }
  },

}

export default {
  namespaced: true, state, mutations, getters, actions
}